import { useCallback, useEffect } from "react";
import { setViewData } from "../../features/recentlyView/RecentlyViewSlice";
import {
  ADD_RECENT_VIEWED_PRODUCT,
  GET_RECENTLY_VIEWED,
} from "./RecentyViewed.gql";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";

export const useRecentlyViewed = () => {
  const dispatch = useDispatch();
  const { isSignedIn } = useSelector((state) => state.loginSlice);
  const recentlyViewedData = useSelector((state) => state.recentlyViewed);
  const [addrecentViewedProduct] = useMutation(ADD_RECENT_VIEWED_PRODUCT);

  const updateRecentlyViewedData = useCallback(
    (data) => {
      const recentData =
        data && data.recentViewedProducts && data.recentViewedProducts.items;
      if (recentData && recentData.length) {
        dispatch(setViewData(recentData));
        if (recentlyViewedData && recentlyViewedData.length) {
          const ids = recentlyViewedData
            .filter((e) => {
              return !recentData.find((r) => r.id === e.id);
            })
            .map((d) => d.id);
          if (ids && ids.length)
            addrecentViewedProduct({
              variables: {
                products: ids.reverse(),
              },
            });
        }
      }
    },
    [recentlyViewedData]
  );

  const [getRecentlyViewedData] = useLazyQuery(GET_RECENTLY_VIEWED, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    onCompleted: updateRecentlyViewedData,
  });

  useEffect(() => {
    if (isSignedIn) {
      getRecentlyViewedData();
    }
  }, [isSignedIn]);

  return {};
};
